var React = require('react');

function MoodFilterIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#025A4D","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"M8.5 7v.75m4.5 0V7m.75 6c-.075.15-1.2 1.5-3 1.5-.15 0-1.875 0-3-1.5m12.75-2.25c0 5.385-4.365 9.75-9.75 9.75S1 16.135 1 10.75 5.365 1 10.75 1s9.75 4.365 9.75 9.75Z"}));
}

MoodFilterIconInline.defaultProps = {"width":"22","height":"22","fill":"none","viewBox":"0 0 22 22"};

module.exports = MoodFilterIconInline;

MoodFilterIconInline.default = MoodFilterIconInline;
